import React, { useEffect, useState, useRef, memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import PerfectScrollbar from 'react-perfect-scrollbar'; // Ensure you have react-perfect-scrollbar installed
import 'react-perfect-scrollbar/dist/css/styles.css';
import '../../css/Inbox.css';
import { inboxActions } from "../../_store/inbox.slice";
import CustomModal from "../../components/common/CustomModal ";
import Button from "../../components/common/ui/Button";
import { MyContactsActions } from "../../_store/MyContacts.slice";
import { showAlert } from "../../components/common/showAlert";
import { useNavigate } from "react-router-dom";
import PaymentModal from "./PaymentModal";
import CustomKeyboard from "../../components/common/CustomKeyboard";
import Loader from "../../components/common/Loader";
import TextAreaInput from "../../components/common/ui/Inputs/TextAreaInput";
import { KioskDashboardActions } from "../../_store";
import messageRead from "../../assets/images/messageread.png";
import messagesent from "../../assets/images/msg-sent.png";
import TranslateFile from "../../Loc/TranslateFile";
import closeIcon from "../../assets/close-icon.svg";
import quickicon from "../../assets/quickmenu.svg";
import GraphemeSplitter from 'grapheme-splitter';
import useCheckQuarantineWords from "../../hooks/useCheckQuarantineWords";
import { getStoredValue } from "../../_helpers/storageHelper";

const Inbox = ({ inboxlist, setinboxlist, chatContainerRef, isupdateScroll, setisupdateScroll, loadMoreMessages, handleNewChat, formData, setFormData, setisOpenPaymentModal, isLoading, inmateInboxMessageHistoryList, setinmateInboxMessageHistoryList }) => {
    const dispatch = useDispatch();
    const currentLang = TranslateFile();
    const { ArchiveinboxMessagesList, InmateInboxMessageResponse, CactasServiceDetailsResult, PublicInboxMessageSubjectList } = useSelector((state) => state.inbox);
    const [InmateInboxMessageSubjectList, setInmateInboxMessageSubjectList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const { loginResponse } = useSelector(state => state.kioskLogin);
    const storedloginResponse = loginResponse || getStoredValue("loginResponse");
    const storedLoginDetails = getStoredValue("loginDetails");
    const [selectedChatId, setSelectedChatId] = useState(null);
    const [key, setKey] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [modalContent, setModalContent] = useState(currentLang?.AlertPopup?.Same_Emoji_Content);
    const [modalContentColor, setmodalContentColor] = useState('#1d1d1d');
    const filteredMessages = formData?.activeTab === 'inbox' ? InmateInboxMessageResponse : ArchiveinboxMessagesList;
    const [isdeleteAll, setisdeleteAll] = React.useState(false);
    const [isfilterCODmsg, setisfilterCODmsg] = useState(false);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
    const [checkedStates, setCheckedStates] = useState({}); // Keep track of individual checkboxes
    const navigate = useNavigate();
    const [isOpenModal, setisOpenModal] = React.useState(false);
    const [selectedMessage, setselectedMessage] = useState();
    const [currentField, setCurrentField] = useState('');
    const [values, setvalues] = useState({});
    const [errorMessage, setErrorMessage] = useState({});
    const [showBoard, setShowBoard] = useState(false);
    const [isConnectionCancelled, setisConnectionCancelled] = useState(false);
    const [isdeletemsg, setisdeletemsg] = useState(false);
    const [isprevsearchvalue, setisprevsearchvalue] = useState();
    const [isMenuActive, setMenuActive] = useState(false);
    const { innerWidth: width, innerHeight: height } = window;
    const LoadQuarantineWords = useCheckQuarantineWords();

    const handleToggle = () => {
        setMenuActive(!isMenuActive);
    };

    const handleSeach = (value) => {
        setFormData(prevFormData => ({
            ...prevFormData, search: value,
        }));
        if (value?.trim()?.length > 0) {
            setinboxlist(
                (formData?.searchinboxlist?.length > 0 ? formData?.searchinboxlist : inboxlist)
                    //  (formData?.activeTab === 'inbox' ? InmateInboxMessageResponse : ArchiveinboxMessagesList)
                    ?.filter((message) => {
                        const searchValue = value?.toLowerCase().replace(/\./g, ''); // Remove periods from search input
                        const messageFrom = message?.MessageFrom?.toLowerCase().replace(/\./g, ''); // Remove periods from message sender
                        const messageSubject = message?.MessageSubject?.toLowerCase().replace(/\./g, ''); // Remove periods from subject
                        return (
                            messageFrom.includes(searchValue) ||
                            messageSubject.includes(searchValue)
                        );
                    })
            );

        }
        else {
            setinboxlist((formData?.activeTab === 'inbox' ? InmateInboxMessageResponse : ArchiveinboxMessagesList))
        }
    }

    useEffect(() => {
        if (PublicInboxMessageSubjectList?.length > 0) {
            setInmateInboxMessageSubjectList(PublicInboxMessageSubjectList[0]);
        }
    }, [PublicInboxMessageSubjectList]);

    useEffect(() => {
        if (formData?.pageNo == 1) {
            setinboxlist(filteredMessages?.filter((message, index, self) =>
                index === self.findIndex((m) => m.MessageID === message.MessageID)
            ));
        }
    }, [filteredMessages]);

    const handleinboxscroll = () => {
        const newPage = formData?.currentPage + 1;
        setFormData(prevFormData => ({
            ...prevFormData,
            currentPage: newPage,
        }));
        loadMoreMessages(selectedChatId?.MessageID, newPage);
    }

    const handleScroll = () => {
        if (inboxlist?.length !== inboxlist[0]?.TotalMessageCount) {
            const newPage = formData?.pageNo + 1;
            setFormData(prevFormData => ({
                ...prevFormData,
                pageNo: newPage,
            }));
            if (formData?.activeTab !== 'inbox') {
                const params = { isScroll: true, inmatesId: storedloginResponse?.InmateID, messageID: 0, pageNo: newPage, rowCountPerPage: 10, sortField: '' };
                dispatch(inboxActions.LoadInmateInboxArchiveMessage(params)).then(x => {
                    if (x?.payload?.length > 0) {
                        setinboxlist(prevMessages => [
                            ...prevMessages,
                            ...x?.payload
                        ]);
                        setFormData(prevFormData => ({
                            ...prevFormData,
                            searchinboxlist: [...inboxlist, ...x?.payload]
                        }));
                    }
                });
            }
            else {
                const Objectdata = {
                    inmatesId: storedloginResponse?.InmateID, messageID: 0, receiverRead: 2, userFirstName: '', userLastName: '', subject: '', messageBody: '', pageNo: newPage,
                    sortField: "", rowCountPerPage: 10, isScroll: true
                };
                dispatch(inboxActions.LoadInmateInboxMessage(Objectdata)).then(x => {
                    if (x?.payload?.length > 0) {
                        setinboxlist(prevMessages => [
                            ...prevMessages,
                            ...x?.payload
                        ]);
                        setFormData(prevFormData => ({
                            ...prevFormData,
                            searchinboxlist: [...inboxlist, ...x?.payload]
                        }));
                    }
                });
            }
        }
    };

    useEffect(() => {
        if (selectedChatId) {
            loadMoreMessages(selectedChatId.MessageID, 1, isfilterCODmsg ? 1 : 0, formData?.currentPage == 1 ? false : true);
        }
    }, [selectedChatId, isfilterCODmsg]);

    const handleChatItemClick = async (MessageID, inmatesId, message) => {
        setinmateInboxMessageHistoryList([]);
        setFormData(prevFormData => ({
            ...prevFormData, writeMessage: '',
            pageNo: 1, search: '', currentPage: 1,
        }));
        setSelectedChatId({ MessageID, inmatesId });
        setMenuActive(false);
        await dispatch(inboxActions.LoadInmateInboxMessageSubject({ MessageID, inmatesId }))
            .then((response) => {
                if (response.payload && response.payload?.length > 0) {
                    setInmateInboxMessageSubjectList(response.payload[0]);
                    setisupdateScroll(true);
                    dispatch(inboxActions.LoadInmatePublicCreditBalanceResult({
                        inmatesId: storedloginResponse?.InmateID,
                        userId: response.payload[0]?.PublicUserID || 0,
                        pUIConnectionID: response.payload[0]?.PUIConnectionID || 0,
                    }));
                    setisConnectionCancelled(response.payload[0]?.DeactivateMyAccount == 0 ? false : true);
                    if (response.payload[0]?.MessageUnReadCount > 0) {
                        const podCode = storedLoginDetails?.PodCode;
                        const inmateID = storedloginResponse?.InmateID;
                        if (inmateID && podCode) {
                            dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode }));
                        }
                        setFormData(prevFormData => ({
                            ...prevFormData,
                            pageNo: 1,
                        }));
                        handlepageOnLoad(1);
                    }
                }
                setFormData(prevFormData => ({ ...prevFormData, isShowList: false }));
            });
        if (message?.CODMessageCount > 0) {
            setTimeout(() => {
                setShowPopup(true); setmodalContentColor('#1d1d1d');
                setModalContent(currentLang?.AlertPopup?.COD_Message_Thread)
            }, 300);
        }
    };

    const handlePopup = (message) => {
        setFormData(prevFormData => ({
            ...prevFormData,
            totalMessageCost: message?.DebitCostOfFacility,
        }));
        showAlert(
            navigate,
            currentLang?.AlertPopup?.Message,
            currentLang?.AlertPopup?.What_would_you_like_todo,
            "question",
            "700px",
            currentLang?.Buttons?.Approve,
            null, // Default redirect URL
            null,  // Redux dispatch function, optional
            null, // Redux action to dispatch, optional (should be passed as a function)
            true,  // Flag to toggle between OK and Yes/No
            currentLang?.Buttons?.Reject, // Optional cancel button text if useConfirmCancel is true
            () => {
                setisOpenModal(true); setselectedMessage(message);
            },
            () => handleUpdateCODMsg('1', message, "0", formData?.balance),
            true
        );
    }

    const ApproveUpdateCODmsg = async (paymentType, taskGUID, balanceValue) => {
        handleUpdateCODMsg('0', selectedMessage, paymentType, balanceValue)
    }

    const handleUpdateCODMsg = (typeOfAction, message, paymentType, balanceValue) => {
        setisdeletemsg(true); setisOpenModal(false);
        const payload = {
            messageID: message?.MessageID,
            messaegSentDate: message?.MessageSentDate,
            dbetCostOfFacility: message?.DebitCostOfFacility,
            inmatesID: message?.InmateID,
            messagetxt: message?.MessageBody,
            facilityID: storedloginResponse?.facilityID,
            typeOfAction: typeOfAction,
            sender: message?.Sender,
            accountType: paymentType,
            cactaBalance: balanceValue,
            inmateResidentID: storedloginResponse?.InmatesResdId,
            taskNo_COD: 0,
            chatPUI: message?.PUIConnectionID,
            userID: message?.PublicUserID
        };

        dispatch(inboxActions.LoadUpdateCODMessage(payload)).then(x => {
            setisdeletemsg(false);
            switch (x?.payload) {
                case 1:
                    loadMoreMessages(selectedChatId.MessageID, 1, 0, formData?.currentPage == 1 ? false : true); setmodalContentColor('#4a9a93');
                    setModalContent(typeOfAction == '0' ? currentLang?.AlertPopup?.Approved_Successfully : currentLang?.AlertPopup?.Rejected_Successfully); setShowPopup(true);
                    if (InmateInboxMessageSubjectList?.MessageSubject == "C.O.D Pending") {
                        let MessageID = message?.MessageID; let inmatesId = message?.InmateID;
                        dispatch(inboxActions.LoadInmateInboxMessageSubject({ MessageID, inmatesId }))
                            .then((response) => {
                                if (response.payload && response.payload?.length > 0) {
                                    setInmateInboxMessageSubjectList(response.payload[0]);
                                    setisupdateScroll(true);
                                    dispatch(inboxActions.LoadInmatePublicCreditBalanceResult({
                                        inmatesId: storedloginResponse?.InmateID,
                                        userId: response.payload[0]?.PublicUserID || 0,
                                        pUIConnectionID: response.payload[0]?.PUIConnectionID || 0,
                                    }));
                                    setisConnectionCancelled(response.payload[0]?.DeactivateMyAccount == 0 ? false : true);
                                    if (response.payload[0]?.MessageUnReadCount > 0) {
                                        const podCode = storedLoginDetails?.PodCode;
                                        const inmateID = storedloginResponse?.InmateID;
                                        if (inmateID && podCode) {
                                            dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode }));
                                        }
                                        handlepageOnLoad();
                                    }
                                }
                                setFormData(prevFormData => ({ ...prevFormData, isShowList: false }));
                            });
                    }
                    break;
                case -1:
                    setModalContent(currentLang?.AlertPopup?.Low_balance); setShowPopup(true); setmodalContentColor('#c8605e');
                    break;
                case -3:
                    setModalContent(currentLang?.AlertPopup?.Data_Not_Available); setShowPopup(true); setmodalContentColor('#c8605e');
                    break;
                case -4:
                    setModalContent(currentLang?.AlertPopup?.CACTAS_credits_not_enabled); setShowPopup(true); setmodalContentColor('#c8605e');
                    break;
                case -5:
                    setModalContent("An internal error has occurred. Please contact the administrator."); setShowPopup(true); setmodalContentColor('#c8605e');
                    break;
            }
            // var inmatesId = message?.InmateID; var MessageID = message?.MessageID
            // dispatch(inboxActions.LoadInmateInboxMessageSubject({ MessageID, inmatesId }));
            const podCode = storedLoginDetails?.PodCode;
            const inmateID = storedloginResponse?.InmateID;
            if (inmateID && podCode) { dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode })); }
            dispatch(inboxActions.LoadInmateFreeCreditBalanceResult({
                inmateResidentID: storedloginResponse?.InmatesResdId,
                facilityId: storedloginResponse?.facilityID,
            }));
            // dispatch(inboxActions.LoadCactasServiceDetailsResult({ facilityId: storedloginResponse?.facilityID }));
            dispatch(inboxActions.LoadInmatePublicCreditBalanceResult({
                inmatesId: storedloginResponse?.InmateID,
                userId: InmateInboxMessageSubjectList?.PublicUserID || 0,
                pUIConnectionID: InmateInboxMessageSubjectList?.PUIConnectionID || 0,
            }));
        })
    }

    const handlepageOnLoad = (page = formData?.pageNo) => {
        if (formData?.activeTab !== 'inbox') {
            setisdeletemsg(true);
            const params = { inmatesId: storedloginResponse?.InmateID, messageID: 0, pageNo: page, rowCountPerPage: 10, sortField: '' };
            dispatch(inboxActions.LoadInmateInboxArchiveMessage(params)).then(x => {
                setisdeletemsg(false);
            });
        }
        else {
            setisdeletemsg(true);
            const Objectdata = {
                inmatesId: storedloginResponse?.InmateID, messageID: 0, receiverRead: 2, userFirstName: '', userLastName: '', subject: '', messageBody: '',
                pageNo: page, sortField: "", rowCountPerPage: 10,
            };
            dispatch(inboxActions.LoadInmateInboxMessage(Objectdata)).then(x => {
                setisdeletemsg(false);
            })
        }
    }

    useEffect(() => {
        handlepageOnLoad();
    }, [dispatch, currentPage, formData?.activeTab]);


    // Filter the messages based on the search query
    let filteredMessageHistoryList = inmateInboxMessageHistoryList?.filter(message =>
        message?.MessageBody?.toLowerCase()?.includes(formData?.search?.toLowerCase())
    ) || [];

    if (isfilterCODmsg) {
        filteredMessageHistoryList = inmateInboxMessageHistoryList?.filter(message =>
            message?.MessageStatus === "C.O.D Pending"
        ) || [];
    }

    useEffect(() => {
        if (isupdateScroll) {
            setTimeout(() => {
                if (chatContainerRef?.current) {
                    chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
                }
            }, 1500);
            scrollToBottom();
            setisupdateScroll(false);
        }
    }, [InmateInboxMessageSubjectList, inmateInboxMessageHistoryList]);

    const messageRef = useRef(null);

    // Function to scroll to the bottom of the container
    const scrollToBottom = () => {
        if (messageRef.current) {
            messageRef.current.scrollTop = messageRef.current.scrollHeight;
        }
    };

    const MessageCard = ({ isChecked, onCheckboxChange, MessageStatus, index, messageID, text, timestamp, onDelete }) => (
        isdeleteAll ? (
            <div className="message-item">
                <div className="widget-chat-message" dangerouslySetInnerHTML={{ __html: text }} />

                <div class="col-date"><div class="col-time">{timestamp}</div></div>
                {(filteredMessageHistoryList?.length > 0 && MessageStatus !== "C.O.D Pending"
                    && filteredMessageHistoryList[0]?.MessageID !== messageID
                ) && <input type="checkbox" className="message-checkbox" checked={isChecked}
                    onChange={() => onCheckboxChange(messageID)} />}
            </div>
        ) : (
            <div className="message-item">
                <div className="widget-chat-message" dangerouslySetInnerHTML={{ __html: text }} />
                {(filteredMessageHistoryList?.length > 0 && MessageStatus !== "C.O.D Pending"
                    && filteredMessageHistoryList[0]?.MessageID !== messageID
                ) && <div className="message-footer">
                        <button className="delete-btn" onClick={onDelete}>
                            <i className="fa-solid fa-trash-can"></i>
                        </button>
                    </div>}
                <div className="col-date"><div className="col-time">{timestamp}</div></div>
            </div>
        )
    );


    const handleSelectAllChange = () => {
        const newSelectAllState = !isSelectAllChecked;
        setIsSelectAllChecked(newSelectAllState);
        const newCheckedStates = {};
        let filterdeletemsg = filteredMessageHistoryList?.slice(1)?.filter(x => x?.Sender !== "Inmate" && x?.MessageStatus !== "C.O.D Pending");
        filterdeletemsg?.forEach((messageID) => {
            newCheckedStates[messageID?.MessageID] = newSelectAllState;
        });
        setCheckedStates(newCheckedStates);
    };

    // Handle individual checkbox change
    const handleCheckboxChange = (messageID) => {
        const newCheckedStates = {
            ...checkedStates,
            [messageID]: !checkedStates[messageID],
        };
        setCheckedStates(newCheckedStates);
        let filterdeletemsg = filteredMessageHistoryList?.slice(1)?.filter(x => x?.Sender !== "Inmate" && x?.MessageStatus !== "C.O.D Pending");
        const allChecked = filterdeletemsg?.every(({ MessageID }) => newCheckedStates[MessageID]);
        setIsSelectAllChecked(allChecked);
    };

    const handleDeleteConfirmation = (item) => {
        showAlert(
            navigate,
            currentLang?.AlertPopup?.Message,
            currentLang?.AlertPopup?.Delete_Conversation,
            "question",
            "700px",
            currentLang?.Buttons?.Yes,
            null, // Default redirect URL
            null,  // Redux dispatch function, optional
            null, // Redux action to dispatch, optional (should be passed as a function)
            true,  // Flag to toggle between OK and Yes/No
            currentLang?.Buttons?.No, // Optional cancel button text if useConfirmCancel is true
            () => handleDelete(item)
        );


    };
    const handleDelete = (item) => {
        // Handle the delete logic here
        let isAllDelete = Object.values(checkedStates)?.some(value => value === true)
        if (!isAllDelete) {
            if (item?.InmateID && item?.MessageID) {
                dispatch(inboxActions.LoadInsertUpdateUspInmateInboxMessageDelete({ inmatesId: item?.InmateID, messageID: item?.MessageID, facilityID: item?.FacilityID })).then(x => {
                    const findMsgId = filteredMessageHistoryList?.filter(x => x?.MessageID !== item?.MessageID);
                    loadMoreMessages(findMsgId[findMsgId?.length - 1]?.MessageID, 1, 0, formData?.currentPage == 1 ? false : true);
                })
            }
        }
        else {
            setisdeletemsg(true);
            let deletmsg = filteredMessageHistoryList?.slice(1)?.filter(x => x?.Sender !== "Inmate" && x?.MessageStatus !== "C.O.D Pending");
            deletmsg = deletmsg?.filter(
                (message) => checkedStates[message.MessageID] === true
            )
            if (deletmsg && deletmsg.length > 0) {
                // Create an array of dispatch Promises
                const deletePromises = deletmsg?.map(msg =>
                    dispatch(inboxActions.LoadInsertUpdateUspInmateInboxMessageDelete({
                        inmatesId: msg?.InmateID,
                        messageID: msg?.MessageID,
                        facilityID: msg?.FacilityID
                    }))
                );
                // Execute all Promises and chain with `then`
                Promise.all(deletePromises)
                    .then(() => {
                        const lastMessageID = filteredMessageHistoryList[0]?.MessageID;
                        return loadMoreMessages(lastMessageID, 1, 0, formData?.currentPage == 1 ? false : true);
                    })
                    .catch(error => {
                        console.error("Error while deleting messages or loading more:", error);
                    })
                    .finally(() => {
                        setisdeletemsg(false); setisdeleteAll(false); setCheckedStates({})
                    });
            } else {
                // Handle case when there are no messages to delete
                console.warn("No messages to delete.");
                setisdeletemsg(false); setisdeleteAll(false); setCheckedStates({})
            }
        }
    }

    const handleNewmsgConfirmation = (selectedrow) => {
        showAlert(
            navigate,
            currentLang?.AlertPopup?.Message,
            currentLang?.AlertPopup?.Redirect_Page,
            "question",
            "700px",
            currentLang?.Buttons?.Yes,
            null, // Default redirect URL
            null,  // Redux dispatch function, optional
            null, // Redux action to dispatch, optional (should be passed as a function)
            true,  // Flag to toggle between OK and Yes/No
            currentLang?.Buttons?.No, // Optional cancel button text if useConfirmCancel is true
            () => handleNewChat(selectedrow)
        );
    }
    // Cancel Request
    const UpdateConnectionConfiramation = (selectedrow) => {
        showAlert(
            navigate,
            currentLang?.AlertPopup?.Message,
            currentLang?.AlertPopup?.Cancel_Confirm,
            "question",
            "700px",
            currentLang?.Buttons?.Yes,
            null, // Default redirect URL
            null,  // Redux dispatch function, optional
            null, // Redux action to dispatch, optional (should be passed as a function)
            true,  // Flag to toggle between OK and Yes/No
            currentLang?.Buttons?.No, // Optional cancel button text if useConfirmCancel is true
            () => UpdateConnection(selectedrow)
        );
    }

    const UpdateConnection = (selectedrow) => {
        if (selectedrow?.PUIConnectionID) {
            const requestData = {
                puiConnectionID: selectedrow?.PUIConnectionID,
                userID: selectedrow?.PublicUserID,
                inmatesId: selectedrow?.InmateID,
                facilityID: selectedrow?.FacilityID,
                requestChangeUser: "Inmate",
                toConnectionStatusID: 4,
                action: 0,
                isSALoginAsPU: 0,
                inmateResidentID: storedloginResponse?.InmatesResdId,
                relationShip: "",
                inmateInvitePublicUserID: 0
            };
            dispatch(MyContactsActions.loadUpdateInmateConnection(requestData)).then(x => {
                switch (x?.payload) {
                    case 1: setisConnectionCancelled(true);
                        setModalContent(currentLang?.AlertPopup?.Connection_Cancel_Success); setShowPopup(true); setmodalContentColor('#4a9a93');
                        break;
                    case -1:
                        setModalContent(currentLang?.AlertPopup?.Operation_Failed); setShowPopup(true); setmodalContentColor('#c8605e');
                        break;
                    case -2:
                        setModalContent(currentLang?.AlertPopup?.Not_Request_Rejected_By_Inmate); setShowPopup(true); setmodalContentColor('#c8605e');
                        break;
                    case -3:
                        setModalContent(currentLang?.AlertPopup?.Not_Request_Accept_By_Inmate); setShowPopup(true); setmodalContentColor('#c8605e');
                        break;
                    case -4:
                        setModalContent(currentLang?.AlertPopup?.Not_Request_Cancel_By_PU); setShowPopup(true); setmodalContentColor('#c8605e');
                        break;
                    case -5:
                        setModalContent(currentLang?.AlertPopup?.Not_Request_Accept_By_PU); setShowPopup(true); setmodalContentColor('#c8605e');
                        break;
                    case -6:
                        setModalContent(currentLang?.AlertPopup?.The_Inmate_Connection_Limit_Exceeded); setShowPopup(true); setmodalContentColor('#c8605e');
                        break;
                }
            });
        }
    }

    const handleCancel = () => {
        setFormData(values);
    }

    const findGraphemeClusters = (input, returnInput) => {
        const splitter = new GraphemeSplitter();
        const graphemes = splitter.splitGraphemes(input);

        if (returnInput) {
            return graphemes.slice(0, 19).join('') + '...';
        } else {
            return graphemes;
        }
    };

    const formatDateTime = (date) => {
        if (!date) return "";

        const d = new Date(date);

        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const year = d.getFullYear();

        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, "0");

        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12; // convert 0 → 12

        return `${month}/${day}/${year} ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
    };

    const UserInboxItem = ({ message, index }) => {
        return (
            <div key={index} className={`messenger-chat-item ${message.unreadCount ? 'active' : ''}`}>
                <a
                    className="messenger-chat-link"
                    onClick={() => handleChatItemClick(message.MessageID, message.InmateID, message)}
                >
                    <div className="col-inbox">
                        <div className="user-inbox">
                            {message.UnReadMessageCount !== 0 && (
                                <div i className="user-unread-msg" >{message.UnReadMessageCount}</div>
                            )}
                            <i className="fa fa-user-circle" aria-hidden="true"></i>
                        </div>
                    </div>
                    <div className="messenger-chat-content">
                        <div className="messenger-chat-title">
                            <div className={message?.UnReadMessageCount !== 0 ? "bold-text" : ""}>{message.MessageFrom || 'No Subject'}</div>
                            <div className="messenger-chat-time">{formatDateTime(message.MessageSendDateTime)}</div>
                        </div>
                        <div className="messenger-chat-title">
                            <div className="MessageSubject" style={{ width: width - 600 }}> {findGraphemeClusters(message.MessageSubject, false)?.length > 20 ? findGraphemeClusters(message.MessageSubject, true) : message.MessageSubject || 'No message body'}</div>
                            <div className="messenger-chat-time">{message.CODMessageCount > 0 && (
                                <label
                                    title={currentLang?.COD_Message}
                                    className="StatusPatch-dangerCOD btn-danger"
                                >
                                    {currentLang?.COD_Message}
                                </label>
                            )}</div>
                        </div>
                    </div>
                </a>
            </div>
        );
    };

    const handleFieldClick = (field) => {
        setCurrentField(field);
        setShowBoard(true); // Show the keyboard when a field is clicked
        setvalues(formData);
    };

    const handleSend = async () => {
        //  dispatch(inboxActions.LoadCactasServiceDetailsResult({ facilityId: storedloginResponse?.facilityID }));
        setFormData({ ...formData, ["PublicUserID"]: InmateInboxMessageSubjectList?.PublicUserID });
        dispatch(inboxActions.LoadInmatePublicCreditBalanceResult({
            inmatesId: storedloginResponse?.InmateID,
            userId: InmateInboxMessageSubjectList?.PublicUserID || 0,
            pUIConnectionID: InmateInboxMessageSubjectList?.PUIConnectionID || 0,
        }));
    };

    const handleSubmit = async (item) => {
        setselectedMessage('');
        if (formData?.writeMessage?.trim()?.length == 0) {
            setmodalContentColor("#1d1d1d"); setModalContent(currentLang?.AlertPopup?.Please_enter_body_content); setShowPopup(true);
            return;
        }

        // const x = await LoadQuarantineWords(formData?.writeMessage);
        // if (x?.isQuarantineWords && x?.highlightedWords) {
        //     setModalContent(`Your message contains restricted word(s): ${x.highlightedWords}. Please remove the word and try again.`);
        //     setmodalContentColor('#c8605e');
        //     setShowPopup(true);
        //     return;
        // } else {
        await handleSend();
        setFormData(prevFormData => ({
            ...prevFormData,
            replyMessageID: item?.SourceReplyMessageID,
            subject: item?.MessageSubject,
            writeMessage: formData?.writeMessage
        }));
        setisOpenPaymentModal(true);
        // }
    };

    const getMessageIcon = (status) => {
        switch (status) {
            case 'Read':
                return <span className="tick-icon read"><img src={messageRead} alt="Read" /></span>;
            case 'Delivered':
                return <span className="tick-icon delivered"><img src={messageRead} alt="Delivered" /></span>;
            case 'C.O.D Pending':
            case 'Rejected':
                return <span className="tick-icon pending mt-2 m-2">
                    <i className="fa-regular fa-clock"></i>
                </span>;
            default:
                return <span className="tick-icon sent"><img src={messagesent} alt="Sent" /></span>;
        }
    };

    return (
        <div className={'messenger'} >

            {/* MessageList Page */}
            {formData?.isShowList ?
                <div className="messenger-chat">
                    <div className="messenger-chat-header d-flex">
                        <div className="flex-1 position-relative margin-10">
                            <input
                                //type="search"
                                className="form-control border-0 bg-light pad-left-30 padding-search"
                                placeholder={currentLang?.Messages?.Search_Placeholder}
                                value={formData?.search}
                                onClick={() => { setShowBoard(true); setisprevsearchvalue(formData?.search) }}
                            />
                            <i className="fa fa-search search-icon"></i>
                        </div>
                    </div>
                    <div className="messenger-chat-body">
                        <PerfectScrollbar className="h-100">
                            <div className="messenger-chat-list">
                                {inboxlist?.length > 0 ? (
                                    inboxlist?.map((message, index) => (
                                        <UserInboxItem message={message} index={index} />
                                    ))
                                ) : (!isLoading && <span className="col-no-data">{currentLang?.No_Data_Found}</span>)}
                                {inboxlist?.length > 0 && (inboxlist?.length !== inboxlist[0]?.TotalMessageCount && formData?.search?.trim()?.length == 0) &&
                                    <div className="mt-1 div-load-more">
                                        <button title={formData?.pageNo} onClick={() => { handleScroll() }} className="btn btn-outline-secondary btn-sm load-more-btn">
                                            <i className="fa fa-plus"></i> {currentLang?.Messages?.Load_More}
                                        </button></div>}
                            </div>
                        </PerfectScrollbar>
                    </div>

                </div>
                :
                <div className="row inbox-container" ref={messageRef}>
                    {/* Chat Header */}
                    <div className="widget-chat">
                        <div className="widget-chat-header">
                            <div className="d-block">
                                <button
                                    type="button"
                                    className="btn border-0 shadow-none"
                                    onClick={() => {
                                        handlepageOnLoad(1);
                                        setFormData(prevFormData => ({ ...prevFormData, isShowList: true, search: '' }));
                                        setinboxlist((formData?.activeTab === 'inbox' ? InmateInboxMessageResponse : ArchiveinboxMessagesList))
                                        setisfilterCODmsg(false); setisdeleteAll(false); setCheckedStates({});
                                    }}
                                >
                                    <i className="fa fa-chevron-left fa-lg"></i>
                                </button>
                            </div>
                            <div className="user-inbox">
                                <i className="fa fa-user-circle" aria-hidden="true"></i>
                            </div>
                            <div className="widget-chat-header-content">
                                <div className="font-size-15 fw-bold text-default-red line-height-normal" onClick={() => setFormData(prevFormData => ({ ...prevFormData, isShowList: true, currentPage: 1 }))}>
                                    {InmateInboxMessageSubjectList?.PublicUserName || 'Inmate Name'}
                                </div>
                                <div className="font-size-13 mb-0" onClick={() => setFormData(prevFormData => ({ ...prevFormData, isShowList: true, currentPage: 1 }))}>
                                    <div className="subject-label">{currentLang?.Subject} </div>
                                    <div className="subject-content">
                                        {InmateInboxMessageSubjectList?.MessageSubject || 'No Subject'}
                                    </div>
                                    {/* Subject: {InmateInboxMessageSubjectList?.MessageSubject || 'No Subject'} */}
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1 position-relative me-3">
                                    <input
                                        //type="search"
                                        className="form-control border-0 bg-light padding-search"
                                        placeholder={currentLang?.Messages?.Search_Placeholder}
                                        value={formData?.search}
                                        onClick={() => handleFieldClick('search')}
                                    />
                                    <i className="fa fa-search position-absolute top-50 start-0 translate-middle-y ps-3"></i>
                                </div>
                            </div>
                            {/* <div className="user-arrow-inbox text-default-red fs-17">
                                <i className="fa fa-arrow-circle-left" aria-hidden="true"></i> */}
                            {/* <i className={`fa fa-arrow-circle-left me-2 ${isMenuActive ? "fa-arrow-circle-left-active" : ""}`}
                                onClick={handleToggle} ></i> */}

                            <img src={!isMenuActive ? quickicon : closeIcon} onClick={handleToggle} ></img>

                            {/* <div className={`cl-left-menu-message ${isMenuActive ? "cl-left-menu-message-active" : ""}`}>
                            </div> */}
                            {/* </div> */}
                        </div>
                    </div>

                    <div className={isMenuActive ? "col-lg-8 " : "col-lg-12"}>
                        <div className="messenger-content">
                            <div className="widget-chat">

                                {/* Chat Body */}
                                {/* <ScrollContainer maxHeight={'400px'} className="convoscroll-buttons"> */}
                                <div className="widget-chat-body" data-scrollbar="true" style={{ maxHeight: '400px', minHeight: '400px', overflowY: 'auto' }} key={key} ref={chatContainerRef} >
                                    {!isfilterCODmsg && formData?.search?.trim()?.length == 0 && filteredMessageHistoryList?.length > 0 && (filteredMessageHistoryList?.length < filteredMessageHistoryList[0]?.TotalMessageCount) &&
                                        <div className="div-load-more">
                                            <button title={formData?.currentPage} onClick={() => { handleinboxscroll() }} className="btn btn-sm load-more-btn">
                                                <i className="fa fa-plus"></i> {currentLang?.Messages?.Load_More}
                                            </button></div>}
                                    {filteredMessageHistoryList?.length > 0 ? (
                                        filteredMessageHistoryList?.map((message, index) => (
                                            <div key={index} className={`widget-chat-item with-media ${message.Sender === "Inmate" ? "end" : "start"}`}>
                                                <div className="widget-chat-media"></div>
                                                <div className="widget-chat-info">
                                                    {(message.MessageStatus === "C.O.D Pending" && message.IsSenderMsgDelete === false) ? (
                                                        //{(message.MessageStatus === "C.O.D Pending" && message.IsSenderMsgDelete === false) ? (
                                                        <div className={`widget-chat-info-container ${message.Sender === "Inmate" ? "public-user-bg" : ""}`}>

                                                            <div className={` ${message.Sender === "Inmate" ? "" : "message-card"}`} >
                                                                <div title={currentLang?.Messages?.Approve_Reject} className="action-badge" onClick={() => handlePopup(message)}>
                                                                    {currentLang?.Messages?.Approve_Reject}<i className="fa fa-eye ms-2"></i>
                                                                </div>
                                                                <div className="message-content">
                                                                    <p className="message-text">
                                                                        {currentLang?.Messages?.COD_Message}
                                                                    </p>
                                                                    <p className="message-footer" dangerouslySetInnerHTML={{ __html: message.MessageBody }} />
                                                                </div>
                                                            </div>
                                                            <div className="col-date col-datetime"><div className="col-statusCOD"><i title="C.O.D Pending" class="fa-regular fa-clock"></i></div><div class="col-time">{message.MessageSentDate}</div></div>
                                                        </div>

                                                    ) : (
                                                        message.Sender !== "Inmate" ? (
                                                            <div className={`widget-chat-info-container ${message.Sender === "Inmate" ? "public-user-bg" : ""}`}>
                                                                <MessageCard
                                                                    isChecked={checkedStates[message.MessageID] || false}
                                                                    onCheckboxChange={handleCheckboxChange}
                                                                    MessageStatus={message?.MessageStatus}
                                                                    index={index}
                                                                    messageID={message.MessageID}
                                                                    text={message.MessageBody}
                                                                    timestamp={message.MessageSentDate}
                                                                    onDelete={() => handleDeleteConfirmation(message)}
                                                                />
                                                            </div>
                                                        )
                                                            : (
                                                                <div className={`widget-chat-info-container ${message.Sender === "Inmate" ? "public-user-bg" : ""}`}>
                                                                    <div className="widget-chat-message" dangerouslySetInnerHTML={{ __html: message.MessageBody }} />
                                                                    <div className="col-date">
                                                                        <div className="col-status-time">
                                                                            <span className="col-time">
                                                                                {message.MessageSentDate}
                                                                            </span>
                                                                            <div className="col-status">
                                                                                {getMessageIcon(message.MessageStatus)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        (<span className="col-no-data">{currentLang?.No_Data_Found}</span>)
                                    )}
                                </div>
                                {/* </ScrollContainer> */}

                                {/* Chat Input */}


                            </div>
                            {((inmateInboxMessageHistoryList[0]?.ConnectionStatusID == 4 || inmateInboxMessageHistoryList[0]?.ConnectionStatusID == 3 || isConnectionCancelled)) ? (
                                <span class="col-md-12 pt-4 pb-4 d-block border-right">
                                    <span class="alertdanger" >
                                        <label>{currentLang?.Messages?.no_longer_connected}</label>
                                    </span>
                                </span>
                            ) : (
                                <div className="widget-chat-input border-right p-2" >
                                    <div>
                                        <TextAreaInput
                                            name="message"
                                            id="message"
                                            label=""
                                            value={formData?.writeMessage}
                                            onClick={() => handleFieldClick('writeMessage')}
                                            handleChange={(e) => { }}
                                            placeholder={currentLang?.Messages?.Msg_placholder}
                                            rows={1}
                                        />
                                        <div className="d-block mt-2">
                                            <Button icon={'paper-plane'} className="mb-3" label={currentLang?.Buttons?.Send} status="primary" type="submit" onClick={() => { handleSubmit(InmateInboxMessageSubjectList) }} />
                                        </div> </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Sidebar */}
                    {isMenuActive && <div className="col-lg-4 d-flex flex-column thirstypr ps-0">
                        <div className="cl-left-menu-message">
                            <div className="messenger-content">
                                <div className="widget-chat">
                                    <div className="available-credits-section flex-wrap ">
                                        <div className="cost-item d-flex align-items-center">
                                            <h5 title="Message Cost" className="me-2 fw-bold mt-2">
                                                {currentLang?.Messages?.Message_Cost}
                                                <span className="noWrap class-balance ml-5 cost-value">
                                                    $<span id="spnMessageCost">{parseFloat(formData?.facilityMessageCost || 0).toFixed(2)}</span>
                                                </span>
                                            </h5>
                                        </div>
                                        {(CactasServiceDetailsResult?.length > 0 && CactasServiceDetailsResult[0]?.IsEmojiEnabled) && <div className="emoji-cost-item d-flex align-items-center">
                                            <h5 title="Emoji Cost" className="me-2 fw-bold">
                                                {currentLang?.Messages?.Emoji_Cost}
                                                <span className="cost-value ml-5">
                                                    $<span id="spnMessageCost">{parseFloat(formData?.facilityEmojiCost || 0).toFixed(2)}</span>
                                                </span>
                                            </h5>
                                            <span
                                                data-placement="bottom"
                                                data-html="true"
                                                data-toggle="tooltip"
                                                title={currentLang?.AlertPopup?.Same_Emoji_Content}
                                                className="ms-2 mt-1"
                                            >
                                                <i onClick={() => { setShowPopup(true); setModalContent(currentLang?.AlertPopup?.Same_Emoji_Content); setmodalContentColor('#1d1d1d'); }} className="fa fa-info-circle info-emoji" style={{ marginBottom: '15px' }}></i>
                                            </span>
                                        </div>}
                                    </div>

                                    <ul className="submenu-list">

                                        <li onClick={() => {
                                            if (inmateInboxMessageHistoryList[0]?.ConnectionStatusID !== 5 && inmateInboxMessageHistoryList[0]?.ConnectionStatusID !== 4 && inmateInboxMessageHistoryList[0]?.ConnectionStatusID !== 3 && !isConnectionCancelled) {
                                                handleNewmsgConfirmation(InmateInboxMessageSubjectList);
                                            }
                                        }} className={`ActiveSubmenu ActiveNewMail ${(!isfilterCODmsg && inmateInboxMessageHistoryList?.length == 0 || inmateInboxMessageHistoryList[0]?.ConnectionStatusID === 3 || inmateInboxMessageHistoryList[0]?.ConnectionStatusID === 4 || inmateInboxMessageHistoryList[0]?.ConnectionStatusID === 5 || isConnectionCancelled) ? "nocursor" : ""}`}
                                            title={currentLang?.Messages?.New_Message}>
                                            {currentLang?.Messages?.New_Message} <label className="pointer float-end"><i className="fa fa-envelope"></i></label></li>
                                        <li className="liMailHistory ActiveSubmenu" title={currentLang?.Messages?.Message_History} onClick={() => {
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                isShowList: true,
                                            })); setisfilterCODmsg(false);
                                            handleSeach(InmateInboxMessageSubjectList?.PublicUserName || "");
                                        }}>{currentLang?.Messages?.Message_History} <label className="pointer float-end"><i className="fa fa-archive"></i></label></li>
                                        <li className={`lifilterCODMessages ActiveSubmenu ${isfilterCODmsg ? "redcolor" : ""}`} title={currentLang?.Messages?.Filter_COD_Messages} onClick={() => {
                                            setisfilterCODmsg(!isfilterCODmsg);
                                            setTimeout(() => {
                                                setShowPopup(inmateInboxMessageHistoryList?.find(message =>
                                                    message?.MessageStatus === "C.O.D Pending" && message?.IsSenderMsgDelete === false
                                                ) ? true : false); setmodalContentColor('#1d1d1d')
                                            }, 150);;
                                            setModalContent(currentLang?.AlertPopup?.COD_Message_Thread)
                                        }}>{currentLang?.Messages?.Filter_COD_Messages} <label className="pointer float-end"><i className={`fa fa-filter ${isfilterCODmsg ? "redcolor" : ""}`}></i></label></li>
                                        {(inmateInboxMessageHistoryList?.length > 1 && inmateInboxMessageHistoryList?.slice(1)?.filter(x => x?.Sender !== "Inmate" && x?.MessageStatus !== "C.O.D Pending")?.length > 0) && <li className={`ActiveSubmenu ${isdeleteAll ? "redcolor" : ""}`} title={currentLang?.Messages?.Delete_Conversation} onClick={() => { setisdeleteAll(!isdeleteAll); setCheckedStates({}); setIsSelectAllChecked(false) }}>{currentLang?.Messages?.Delete_Conversation} <i className={`fa fa-trash float-end ${isdeleteAll ? "redcolor" : ""}`}></i></li>}
                                        {isdeleteAll && (
                                            <li className="ActiveSubmenu" id="divCheckSelectAll">
                                                <div
                                                    className="inboxchatdelete" id="chkChatSelectAll"
                                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
                                                    onClick={() => handleSelectAllChange({ target: { checked: !isSelectAllChecked } })}
                                                >
                                                    <label
                                                        htmlFor="chkChatSelectAll"
                                                        style={{ marginRight: '10px', cursor: 'pointer' }}
                                                    >
                                                        {currentLang?.Messages?.Select_All_to_Delete}
                                                    </label>
                                                    <input
                                                        type="checkbox"
                                                        id="chkChatSelectAll"
                                                        checked={isSelectAllChecked}
                                                        onClick={handleSelectAllChange}
                                                        style={{ marginLeft: '10px' }} // Prevents direct interaction with the checkbox
                                                    />
                                                </div>

                                                {(isSelectAllChecked || Object.values(checkedStates)?.some(value => value === true)) && (
                                                    <div className="d-flex justify-content-end mt-3">
                                                        <Button className="me-2" label={currentLang?.Buttons?.Delete} status="primary" type="submit" onClick={() => { handleDeleteConfirmation() }} />
                                                        <Button label={currentLang?.Buttons?.Cancel} status="secondary" type="button" onClick={() => setisdeleteAll(!isdeleteAll)} />
                                                    </div>
                                                )}
                                            </li>
                                        )}
                                        <li onClick={() => {
                                            if (inmateInboxMessageHistoryList[0]?.ConnectionStatusID !== 4 && inmateInboxMessageHistoryList[0]?.ConnectionStatusID !== 5 && inmateInboxMessageHistoryList[0]?.ConnectionStatusID !== 3 && !isConnectionCancelled) {
                                                UpdateConnectionConfiramation(InmateInboxMessageSubjectList);
                                            }
                                        }}
                                            className={`ActiveSubmenu ${(!isfilterCODmsg && inmateInboxMessageHistoryList?.length == 0 || inmateInboxMessageHistoryList[0]?.ConnectionStatusID === 4 || inmateInboxMessageHistoryList[0]?.ConnectionStatusID === 5 || inmateInboxMessageHistoryList[0]?.ConnectionStatusID === 3 || isConnectionCancelled) ? "nocursor" : ""}`} title={currentLang?.Messages?.Cancel_Connection}>
                                            {currentLang?.Messages?.Cancel_Connection}<label className="pointer float-end"><i className="fa fa-times-circle"></i></label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>}
                </div>
            }
            {showPopup && (
                <CustomModal
                    color={modalContentColor}
                    content={modalContent}
                    onOkClick={() => { setShowPopup(false) }}
                />
            )}
            {showBoard && (
                formData?.isShowList ?
                    <CustomKeyboard
                        onInputChange={handleSeach}
                        inputValue={formData?.search}
                        // onKeyPress={handleKeyPress}
                        handleCancel={() => {
                            handleSeach(isprevsearchvalue);
                            setFormData(prevFormData => ({
                                ...prevFormData,
                                search: isprevsearchvalue
                            }));
                        }}
                        setShowBoard={setShowBoard}
                        placeholder={currentLang?.Messages?.Search_Placeholder}
                    />
                    :
                    <CustomKeyboard
                        currentField={currentField}
                        setCurrentField={setCurrentField}
                        inputs={formData}
                        setShowBoard={setShowBoard}
                        handleCancel={handleCancel}
                        setInputs={setFormData}
                        fields={[currentField]}
                        setErrorMessage={setErrorMessage}
                        type="Multiple"
                        placeholderList={{
                            search: currentLang?.Messages?.Search_Placeholder,
                            writeMessage: currentLang?.Messages?.Msg_placholder
                        }}
                        IsEmojiEnabled={CactasServiceDetailsResult[0]?.IsEmojiEnabled}
                    />
            )}
            {(isLoading || isdeletemsg) && <Loader isConvo={isdeletemsg ? false : true} />}
            {isOpenModal &&
                <PaymentModal CactasServiceDetailsResult={CactasServiceDetailsResult[0]} selectedMessage={selectedMessage} setFormData={setFormData} SendMessage={ApproveUpdateCODmsg} formData={formData} show={isOpenModal} onClose={() => { setisOpenModal(false) }} />}
        </div>
    );
};

export default memo(Inbox);
